document.addEventListener('DOMContentLoaded', function() {
  const freeShippingThreshold = 6500; // in cents
  
  function updateRemainingAmount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let totalPrice = cart.total_price;
        
        // Check if B2B pricing elements exist (user is logged in with B2B pricing)
        const b2bWithVatElement = document.querySelector('.bss-b2b-cart-with-vat-price');
        
        if (b2bWithVatElement) {
          // Extract the numeric value from the B2B price element
          const priceText = b2bWithVatElement.textContent.trim();
          const priceValue = parseFloat(priceText.replace(/[^0-9.,]/g, '').replace(',', '.'));
          
          if (!isNaN(priceValue)) {
            totalPrice = Math.round(priceValue * 100); // Convert to cents
          }
        }
        
        const remainingAmount = freeShippingThreshold - totalPrice;
        const remainingAmountElements = document.querySelectorAll('.remaining-amount');
        const remainingAmountBoxes = document.querySelectorAll('.remaining-amount-box');
        const freeshippingBoxes = document.querySelectorAll('.free-shipping-box');
        
        remainingAmountElements.forEach(remainingAmountElement => {
          if (remainingAmount <= 0) {
            remainingAmountElement.innerText = '0.00';
          } else {
            remainingAmountElement.innerText = (remainingAmount / 100).toFixed(2);
          }
        });
        
        remainingAmountBoxes.forEach(remainingAmountBox => {
          remainingAmountBox.style.display = remainingAmount <= 0 ? 'none' : 'block';
        });
        
        freeshippingBoxes.forEach(freeshippingBox => {
          freeshippingBox.style.display = remainingAmount <= 0 ? 'block' : 'none';
        });
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
  }
  
  updateRemainingAmount();
  document.addEventListener('cart:updated', updateRemainingAmount);
  
  const originalFetch = fetch;
  fetch = function() {
    return originalFetch.apply(this, arguments).then(response => {
      if (response.url.endsWith('/cart/add.js') || response.url.endsWith('/cart/update.js') || response.url.endsWith('/cart/change.js')) {
        const event = new CustomEvent('cart:updated');
        document.dispatchEvent(event);
      }
      return response;
    });
  };
});